module.exports = __webpack_public_path__ + "static/media/4.c016ede0.jpg";